import type { GenerateOtpDto } from '~shared/types/auth.dto'

import { generateOtp } from '~features/auth/api/generateOtp'

export const sendLoginOtp = async (params: GenerateOtpDto) => {
  return generateOtp(params)
}
